<div class="medlemmer">
  @for (medlem of medlemmer(); track medlem.id) {
    <medlem-listevisning-kompakt [medlem]="medlem"/>
  }
</div>
